import { t } from 'i18next';
import { useState } from 'react';
import { SubTabs } from '../SubTabs';
import { Profile } from '~/helpers/userProfile';
import { SimpleButton } from '../styles';
import { NewTable } from '~/components';
import { ApiResps } from '~/providers';
import { ColumnsTable } from '../ClientPanel';

type MachinePanelProps = {
  state: {
    machinesWithAssetsList: ApiResps['/clients/get-machines-list']&({
      DEVS_QUANTITY?: number
      dacs?: { DAC_ID: string }[]
      checked?: boolean
    }[]);
    machineColumns: ColumnsTable[];
    associationsList: ApiResps['/clients/get-associations-list']['list'] & ({
      checked?: boolean
      UNIT_NAME?: string
      GROUPS_COUNT?: string
    }[]);
    associationsColumns: ColumnsTable[];
    heatExchangersList: ApiResps['/heat-exchanger/get-list-v2'];
    heatExchangerColumns: ColumnsTable[];
  }
  profile: Profile;
  deleteGroup: () => void;
  openCreateEditMachine: () => void;
  openCreateEditHeatExchangere: () => void;
  deleteAssociation: () => void;
  openCreateEditAssociation: () => void;
}
export const MachinePanel = ({
  state,
  profile,
  deleteGroup,
  openCreateEditMachine,
  openCreateEditHeatExchangere,
  deleteAssociation,
  openCreateEditAssociation,
}: MachinePanelProps): JSX.Element => {
  const [activeTab, setActiveTab] = useState(t('maquinas'));
  const canManage = profile.manageAllClients || profile.permissions.isAdminConta;

  return (
    <>
      <SubTabs
        tabs={[t('maquinas'), t('agruparMaquinas'), t('tipoDeTrocadorDeCalor')]}
        activeTab={activeTab}
        onChange={setActiveTab}
      />
      {activeTab === t('maquinas') && (
        <>
          <div style={{ float: 'right' }}>
            {(canManage) && <SimpleButton style={{ fontSize: '80%' }} variant="primary" onClick={() => openCreateEditMachine()}>{t('novaMaquina')}</SimpleButton>}
            {(profile.permissions.isAdminSistema || profile.permissions.isAdminConta) && <SimpleButton style={{ fontSize: '80%' }} variant="primary" onClick={() => deleteGroup()}>{t('excluirMaquinas')}</SimpleButton>}
          </div>
          {(state.machinesWithAssetsList.length === 0) ? (
            <div>{`(${t('nenhuma')})`}</div>
          ) : (
            <NewTable
              data={state.machinesWithAssetsList}
              columns={state.machineColumns}
              pageSize={20}
              keySearch="searchMachine"
            />
          )}
        </>
      )}
      {activeTab === t('agruparMaquinas') && (
        <>
          <div style={{ float: 'right' }}>
            {(profile.permissions.isAdminSistema || profile.permissions.isAdminConta) && <SimpleButton style={{ fontSize: '80%' }} variant="primary" onClick={() => deleteAssociation()}>{t('excluirGrupos')}</SimpleButton>}
            {(canManage) && <SimpleButton style={{ fontSize: '80%' }} variant="primary" onClick={() => openCreateEditAssociation()}>{t('adicionarGrupo')}</SimpleButton>}
          </div>
          {(state.associationsList.length === 0) ? (
            <div>{`(${t('nenhuma')})`}</div>
          ) : (
            <NewTable
              data={state.associationsList}
              columns={state.associationsColumns}
              pageSize={20}
              keySearch="serchGroupMachine"
            />
          )}
        </>
      )}
      {activeTab === t('tipoDeTrocadorDeCalor') && (
        <>
          <div style={{ float: 'right' }}>
            {(canManage) && <SimpleButton style={{ fontSize: '80%' }} variant="primary" onClick={() => openCreateEditHeatExchangere()}>{t('adicionarTipoTrocadorDeCalor')}</SimpleButton>}
          </div>
          <NewTable
            data={state.heatExchangersList}
            columns={state.heatExchangerColumns}
            pageSize={20}
            keySearch="searchHeatExchangers"
          />
        </>
      )}
    </>
  );
};
